import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function deleteCollection(variables: { collectionId: number }): Promise<AxiosResponse<FetchResult<string>>> {
  const response = instance.delete(`/collections/${variables.collectionId}`);
  return response;
}

const useDeleteCollection = () => {
  const { mutate, isPending } = useMutation({
    mutationKey: ['delete', `/collections`],
    mutationFn: (variables: { collectionId: number }) => deleteCollection(variables),
    retry: false
  });

  return { mutate, isPending };
};

export default useDeleteCollection;
